import { TeamAccessType, TeamRole } from '@showbie-socrative/socrative-utils';

import axios from '../localAxios';
import { changeRoleURL } from './urls';

export interface ChangeRoleParams {
  teamId: string;
  memberPublicId: string;
  newRole: TeamRole;
}

interface ChangeRoleResponse {
  publicId: string;
  name: string;
  role: TeamRole;
  accessLevel: TeamAccessType;
  createdDate: string;
}
export async function changeTeamRole({
  newRole,
  memberPublicId,
  teamId,
}: ChangeRoleParams) {
  const url = changeRoleURL({ teamId, publicId: memberPublicId });
  const response = await axios.put<ChangeRoleResponse>(url.href, {
    role: newRole,
  });

  return response.data;
}
